import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface PromoHeaderProps {
  promoCode?: string
}

const PromoHeader = ({ promoCode }: PromoHeaderProps) => {
  const { t } = useTranslation()
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <Typography
        component="a"
        href="/promotions"
        variant="h5"
        sx={{
          color: '#1976d2',
          fontWeight: 600,
          fontSize: 28,
          textDecoration: 'none',
          cursor: 'pointer',
          mr: 1.5,
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        {t('merchant.promos')}&nbsp;&gt;
      </Typography>
      <Typography variant="h5" sx={{ color: '#1976d2', fontWeight: 600, fontSize: 28 }}>
        {t('merchant.promo_merchants_list_title')} : <span style={{ color: '#333' }}>{promoCode}</span>
      </Typography>
    </Box>
  )
}

export default PromoHeader
